import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const useTask = () => {
  const [searchParams] = useSearchParams();
  const [taskId, setTaskId] = useState(null);
  const [frameStart, setFrameStart] = useState(null);
  const [frameEnd, setFrameEnd] = useState(null);
  const [taskType, setTaskType] = useState("supertrack");

  const { frameCount } = useSelector(({ superTracks }) => superTracks);

  useEffect(() => {
    if (!searchParams || typeof searchParams.get !== "function") return;
    const taskId = searchParams.get("taskId");
    const frameStart = searchParams.get("frame_start") ?? 0;
    const frameEnd = searchParams.get("frame_end") || frameCount;
    setTaskId(Number(taskId));
    setFrameStart(Number(frameStart));
    setFrameEnd(Number(frameEnd));

    // Update to support other task types
    const taskType = searchParams.get("type");
    if (["supertrack", "ball"].includes(taskType))
      setTaskType(taskType === "supertrack" ? "supertrack" : "ball_supertrack");
  }, [searchParams, frameCount]);

  return {
    taskId,
    frameStart,
    frameEnd,
    taskType,
  };
};

export default useTask;
